import Gallery from 'vue-gallery';
import { ESTADOS, STATUS_VISTORIA } from "../../util/constantes";
import { mapState, mapActions } from "vuex";
import Util from '../../util/funcoes.js'

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faHome, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import { latLng, icon } from 'leaflet';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'

library.add(faHome, faTimesCircle)

export default {
  components: {
    FontAwesomeIcon,
    LMap,
    LTileLayer,
    LMarker,
    Gallery
  },

  data() {
    return {
      filtroPesquisa: {
        status: 'AGENDADO',
        data: Util.hoje(),
        tipo: 'ENTRADA'
      },

      vistoriaSelecionada: undefined,

      urlMapa: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attributionMapa: '&copy; <a href="http:osm.org/copyright">OpenStreetMap</a> contributors',
      center: latLng(-5.0673272, -42.8014819),
      icon: icon({
        iconUrl: require("../../dashboard/icons/mapIconRed.png"),
        iconSize: [32,37],
        iconAnchor: [16,37]
      }),

      comodos : [
        'Área Gourmet',
        'Área de Serviço',
        'Área de Serviço Coberta',
        'Área Livre',
        'Área Lateral Livre',
        'Banheiro',
        'Banheiro Social',
        'Closet',
        'Copa',
        'Corredor',
        'Cozinha',
        'Cozinha Americana',
        'Cozinha com Lavanderia',
        'Dependência de Empregada',
        'Despensa',
        'Depósito',
        'Escada',
        'Escritório',
        'Garagem',
        'Jardim',
        'Lavabo',
        'Lavanderia',
        'Quarto',
        'Quintal',
        'Sacada',
        'Sala',
        'Sala 02 Ambientes',
        'Sala 03 Ambientes',
        'Sala com Varanda',
        'Sala de Estar',
        'Sala de Jantar',
        'Sala de Estar/Jantar',
        'Terraço',
        'Varanda',
        'Varanda Gourmet',
        'WC de Serviço',
        'WC Social',
        'WC Social com Box',
      ],

      comodoSelecionado: undefined,
      qtdComodo: 1,

      itemComodoSelecionado: undefined,
      qtdItem: 1,
      
      detalheItemSelecionado: undefined,

      comodoEmExibicao: undefined,
      indexComodoEmExibicao: null,
      itemComodoEmExibicao: undefined,

      visibilidadeCamera: false,

      videoStream: null,

      imagemCapturada: null,
      imagemUpload: null,

      imagemSelecionada: null,
      imagemSelecionadaItemComodo: null,
      imagensViewerId: 0,

      isShowGravarObservacoesButton: false,

      visibilidadeEditDescricao: false,

      isExibirLoadingGravarImagem: false,

      isShowPopover: false,

      detalheItemSelecionadoUpdate: undefined
    }
  },

  created() {
    this.listarVistoriasHandler();
  },

  computed: {
    ...mapState({
      isMobile(state) { return state.isMobile }
    }),
    ...mapState('vistoriasStore', {
      listaVistorias(state) { return state.listaVistorias }
    }),

    zoom() {
      return this.vistoriaSelecionada ? 28 : 5 
    },

    itensAreas() {
      return [
        "Pia",
        "Torneira",
        "Registro",
        "Ralo",
        "Forro",
        "Armário",
        "Prateleira",
        "Luminária",
        "Tomada",
        "Parede",
        "Piso",
        "Interruptor",
      ];
    },
    itensBanheiros() {
      return [
        "Acessórios",
        "Pia",
        "Torneira",
        "Espelho",
        "Vaso",
        "Box",
        "Chuveiro",
        "Registro",
        "Basculante",
        "Ducha higiênica",
        "Ralo",
        "Porta",
        "Forro",
        "Armário",
        "Luminária",
        "Tomada",
        "Parede",
        "Piso",
        "Interruptor",
      ];
    },
    itensCozinhas() {
      return [
        "Fogão",
        "Microondas",
        "Forno",
        "Interfone",
        "Filtro de água",
        "Pia",
        "Torneira",
        "Mesa",
        "Porta",
        "Forro",
        "Janela",
        "Armário",
        "Ar condicionado",
        "Prateleira",
        "Luminária",
        "Tomada",
        "Parede",
        "Piso",
        "Interruptor",
      ];
    },
    itensDespensa() {
      return [
        "Porta",
        "Janela",
        "Armário",
        "Parede",
        "Piso",
        "Lâmpada",
        "Interruptor",
      ];
    },
    itensEscada() {
      return [
        "Escada",
        "Corrimão",
        "Forro",
        "Luminária",
        "Parede",
        "Interruptor",
      ];
    },
    itensEscritorio() {
      return [
        "Mesa",
        "Porta",
        "Janela",
        "Prateleira",
        "Parede",
        "Piso",
        "Lâmpada",
        "Interruptor",
      ];
    },
    itensGaragem() {
      return [
        "Porta",
        "Janela",
        "Parede",
        "Piso",
        "Lâmpada",
        "Interruptor",
      ];
    },
    itensLavabo() {
      return [
        "Pia",
        "Torneira",
        "Espelho",
        "Vaso",
        "Box",
        "Chuveiro",
        "Registro",
        "Basculante",
        "Ducha higiênica",
        "Ralo",
        "Porta",
        "Forro",
        "Armário",
        "Luminária",
        "Tomada",
        "Parede",
        "Piso",
        "Interruptor",
      ];
    },
    itensQuarto() {
      return [
        "Porta",
        "Forro",
        "Janela",
        "Armadores",
        "Armário",
        "Ar condicionado",
        "Prateleira",
        "Luminária",
        "Tomada",
        "Cama",
        "Criado-mudo",
        "Guarda-roupas",
        "Cortina",
        "Persiana",
        "Parede",
        "Piso",
        "Interruptor",
      ];
    },
    itensSalas() {
      return [
        "Campainha",
        "Ralo",
        "Mesa",
        "Porta",
        "Forro",
        "Janela",
        "Armário",
        "Ar condicionado",
        "Luminária",
        "Tomada",
        "Persiana",
        "Parede",
        "Piso",
        "Interruptor",
      ];
    },
    itensTerraco() {
      return [
        "Parede",
        "Piso",
        "Lâmpada",
        "Interruptor",
      ];
    },
    itensVarandas() {
      return [
        "Parede",
        "Piso",
        "Lâmpada",
        "Interruptor",
      ];
    },

    statusVistoria() {
      return STATUS_VISTORIA
    },

    comodosVistoria() {
      return this.comodos
    },

    centroMapa() { 
      if(this.vistoriaSelecionada && (this.vistoriaSelecionada.imovel.latitude || this.vistoriaSelecionada.imovel.longitude)) {
        return latLng(this.vistoriaSelecionada.imovel.latitude, this.vistoriaSelecionada.imovel.longitude); 
      } else {
        return latLng(-5.0660888, -42.8042637);
      }
    },

    titulo() {
      return (this.vistoriaSelecionada && this.comodoEmExibicao && !this.itemComodoEmExibicao) ? `${this.comodoEmExibicao.nome}` : (this.vistoriaSelecionada && this.comodoEmExibicao && this.itemComodoEmExibicao) ? this.itemComodoEmExibicao.nome : 'Vistorias'
    },

    urlImagens() {
      if(this.comodoEmExibicao && this.comodoEmExibicao.imagens) {
        return this.comodoEmExibicao.imagens.filter(imagem => {
          return imagem.idItemComodo == 0
        }).map(imagem => imagem.url);
      }

      return [];
    },

    imagens() {
      if(this.comodoEmExibicao && this.comodoEmExibicao.imagens) {
        return this.comodoEmExibicao.imagens.filter(imagem => {
          return imagem.idItemComodo == 0
        });
      }

      return []
    },

    imagensItemComodo() {
      return this.comodoEmExibicao.imagens.filter(imagem => {
        return imagem.idItemComodo && (imagem.idItemComodo === this.itemComodoEmExibicao.id)
      })
    },

    urlImagensItemComodo() {
      if(this.itemComodoEmExibicao && this.comodoEmExibicao.imagens) {
        return this.comodoEmExibicao.imagens.filter(imagem => {
          return imagem.idItemComodo == this.itemComodoEmExibicao.id
        }).map(imagem => imagem.url)
      }

      return [];
    },

    isDesktop() {
      return !this.isMobile;
    },

    isVistoriaConcluida() {
      return this.vistoriaSelecionada && this.vistoriaSelecionada.status === 'CONCLUIDO'
    },

    isPrimeiroComodo() {
      const index = this.vistoriaSelecionada.comodos.findIndex(comodo => comodo === this.comodoEmExibicao);

      return index === 0;
    },

    isUltimoComodo() {
      const index = this.vistoriaSelecionada.comodos.findIndex(comodo => comodo === this.comodoEmExibicao);

      return index + 1 === this.vistoriaSelecionada.comodos.length;
    },

    isPrimeiroItemComodo() {
      const index = this.comodoEmExibicao.itens.findIndex(item => item === this.itemComodoEmExibicao);

      return index === 0;
    },

    isUltimoItemComodo() {
      const index = this.comodoEmExibicao.itens.findIndex(item => item === this.itemComodoEmExibicao);

      return index + 1 === this.comodoEmExibicao.itens.length;
    }
  },
  
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions('vistoriasStore', [
      'listarVistorias',
      'gravarComodos',
      'removerComodo',
      'gravarImagem',
      'removerImagem',
      'atualizarComodo',
      'gravarItensComodo',
      'removerItemComodo',
      'atualizarItemComodo',
      'gravarDetalheItem',
      'atualizarDescricaoDetalhe',
      'removerDetalheItem',
      'concluirVistoria',
      'atualizarObservacoesGerais'
    ]),

    getItensByList(comodoName) {
      switch (comodoName) {
        case "Área Gourmet":
        case "Área de Serviço": 
        case 'Área Livre':
        case 'Área Lateral Livre': 
        case "Área de Serviço Coberta'":
          return this.itensAreas;
        case "Banheiro": 
        case "Banheiro Social": 
        case "WC de Serviço": 
        case "WC Social": 
        case "WC Social com Box":
          return this.itensBanheiros;
        case "Cozinha": 
        case "Cozinha com Lavanderia": 
        case "Cozinha Americana":
          return this.itensCozinhas;
        case "Despensa":
          return this.itensDespensa;
        case "Escada":
          return this.itensEscada;
        case "Escritório":
          return this.itensEscritorio;
        case "Garagem":
          return this.itensGaragem;
        case "Lavabo":
          return this.itensLavabo;
        case "Quarto":
          return this.itensQuarto;
        case "Sala": 
        case "Sala 02 Ambientes": 
        case "Sala 03 Ambientes": 
        case "Sala com Varanda": 
        case "Sala de Estar": 
        case "Sala de Jantar": 
        case "'Sala de Estar/Jantar":
          return this.itensSalas;
        case "Terraço":
          return this.itensTerraco;
        case "Varanda": 
        case "Varanda Gourmet":
          return this.itensVarandas;
        default:
          return [];
      }
    },

    getItemDetails(itemComodo) {
      switch (itemComodo) {
          case 'Espelho':
              return ['Formato'];
  
          case 'Fogão':
          case 'Forno':
              return ['Marca', 'Modelo', 'Tipo'];
  
          case 'Forro':
              return ['Acabamento', 'Cor'];
  
          case 'Interfone':
              return ['Cor'];
  
          case 'Interruptor':
          case 'Tomada':
              return ['Espelho', 'Tipo', 'Cor', 'Quantidade'];
  
          case 'Janela':
              return ['Grade', 'Pelicula', 'Tipo', 'Cor', 'Material', 'Quantidade'];
  
          case 'Luminária':
              return ['Lâmpadas', 'Acabamento', 'Tipo', 'Cor', 'Quantidade'];
  
          case 'Mesa':
              return ['Tipo', 'Cor', 'Formato'];
  
          case 'Microondas':
              return ['Marca', 'Modelo'];
  
          case 'Parede':
          case 'Persiana':
              return ['Revestimento', 'Acabamento', 'Cor'];
  
          case 'Pia':
              return ['Cubas', 'Tipo', 'Cor', 'Material'];
  
          case 'Piso':
              return ['Cor', 'Material'];
  
          case 'Porta':
              return ['Fechadura', 'Portal', 'Trinco', 'Tipo', 'Cor', 'Material'];
  
          case 'Prateleira':
              return ['Cor', 'Quantidade'];
  
          case 'Ralo':
              return ['Fecho', 'Cor', 'Material', 'Quantidade'];
  
          case 'Registro':
              return ['Acabamento', 'Cor', 'Material'];
  
          case 'Torneira':
              return ['Acabamento', 'Mobilidade', 'Material'];
  
          case 'Vaso':
              return ['Marca', 'Cor', 'Formato', 'Material', 'Quantidade'];
  
          default:
              return [];
      }
    },

    listaDetalhes(itemComodo) {
      if(this.itemComodoEmExibicao) {
        return this.getItemDetails(itemComodo)
        .map(item => {
          return {  
            nome: item,
            checked: this.itemComodoEmExibicao.detalhes.find(detalhe => detalhe.nome === item) ? true : false
          }
        })
      }

      return [];
    },

    async exibirCamera() {
      this.showLoading();
      this.visibilidadeCamera = true;

      try {
        const constraint = {
          video: {
            width: { ideal: 1920 },
            height: { ideal: 1080 },
            zoom: true,
            focusMode: true,
            facingMode: { exact: "environment" }
          }
        }

         this.videoStream = await navigator.mediaDevices.getUserMedia(constraint);
        this.$refs.video.srcObject = this.videoStream;
      } catch(error) {
        this.$message.error('Erro ao acessar câmera do dispositivo.')
      } finally {
        this.hideLoading();
      }
    },

    stopCamera() {
      if(this.videoStream) {
        const tracks = this.videoStream.getTracks();
        tracks.forEach(track => track.stop());

        this.videoStream = null;

        this.visibilidadeCamera = false
      }
    },

    capturarImagem() {
      const canvas = this.$refs.canvas;
      const context = canvas.getContext('2d');
      const video = this.$refs.video;

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      context.filter = 'contrast(95%)'

      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      const agora = new Date();

      const dateTimeString = agora.toLocaleString('pt-br');
      context.font = '50px Arial'
      context.fillStyle = 'white'
      context.strokeStyle = 'black'
      context.lineWidth = 4;

      context.strokeText(dateTimeString, 10 , canvas.height- 30);
      context.fillText(dateTimeString, 10, canvas.height - 30);

      this.imagemCapturada = canvas.toDataURL('image/jpeg');
    },

    gravarImagemHandler() {
      this.isExibirLoadingGravarImagem = true;
      const payload = {
        idVistoria: this.vistoriaSelecionada.id,
        base64Image: this.imagemCapturada
      }

      if(this.comodoEmExibicao && !this.itemComodoEmExibicao) {
        payload.idComodo = this.comodoEmExibicao.id
      }

      if(this.comodoEmExibicao && this.itemComodoEmExibicao) {
        payload.idItemComodo = this.itemComodoEmExibicao.id
      }

      this.gravarImagem(payload)
      .then(resposta => {
        if(resposta.status === 'SUCESSO') {
          this.comodoEmExibicao.imagens.push(resposta.item);
          this.$message.success('Imagem enviada com sucesso!');
        }

        if(resposta.status === 'ERRO') {
          this.$message.error('Erro ao comunicar-se com o servidor.')
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.')
      }).finally(() => {
        this.isExibirLoadingGravarImagem = false;
        this.imagemCapturada = null;
      })
    },

    ignorarImagem() {
      this.imagemCapturada = undefined;

      this.exibirCamera();
    },

    triggerUploadImagem() {
      this.$refs.fileInput.click();
    },

    handleUploadImagem(event) {
      const files = event.target.files;
      const totalArquivos = files.length;

      for(let i = 0; i < files.length; i++) {
        if(files[i] && (files[i].type.startsWith('image/jpeg') || (files[i].type.startsWith('image/jpg')))) {
          this.convertToBase64(files[i])
          .then((base64) => {
            this.imagemUpload = base64;
            this.gravarImagemUploadHandler(i+1, totalArquivos)
          }).catch(() => {
            this.$message.error(`Erro ao fazer upload da imagem ${files[i].name}.`)
          });
        } else {
          this.$message.warning('É permitido apenas imagens com formato jpeg e jpg!')
        }
      }

      event.target.value = ''
    },

    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = (error) => {
          reject(error);
        }
      });
    },

    gravarImagemUploadHandler(indice, totalImagens) {
      const payload = {
        idVistoria: this.vistoriaSelecionada.id,
        base64Image: this.imagemUpload
      }

      if(this.comodoEmExibicao && !this.itemComodoEmExibicao) {
        payload.idComodo = this.comodoEmExibicao.id
      }

      if(this.comodoEmExibicao && this.itemComodoEmExibicao) {
        payload.idItemComodo = this.itemComodoEmExibicao.id
      }

      this.gravarImagem(payload)
      .then(resposta => {
        this.imagemCapturada = null;

        if(resposta.status === 'SUCESSO') {
          this.comodoEmExibicao.imagens.push(resposta.item);
          this.$message.success(`Imagem ${indice} de ${totalImagens} selecionas gravada com sucesso!`)
        }

        if(resposta.status === 'ERRO') {
          this.$message.error('Erro ao comunicar-se com o servidor.')
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.')
      })
    },

    listarVistoriasHandler() {
      const payload = {
        status: this.filtroPesquisa.status,
        tipo: this.filtroPesquisa.tipo
      }

      switch(this.filtroPesquisa.status) {
        case 'AGENDADO': 
          payload.dataAgendamento = this.filtroPesquisa.data;
          break;
        case 'CONCLUIDO':
          payload.dataRecebimento = this.filtroPesquisa.data;
          break;
        case 'CANCELADO':
          payload.dataAgendamento = this.filtroPesquisa.data;
          break;
      }

      this.listarVistorias(payload);
    },

    selecionarVistoria(vistoria) {
      this.itemComodoEmExibicao = undefined;
      this.comodoEmExibicao = undefined;
      this.vistoriaSelecionada = vistoria;
    },

    selecionarComodoParaExibicao(comodo, index) {
      this.comodoEmExibicao = comodo
      this.indexComodoEmExibicao = index
    },

    selecionarItemComodoParaExibicao(item) {
      this.itemComodoEmExibicao = item;
    },

    voltarParaListaVistorias() {
      this.vistoriaSelecionada = undefined;
    },

    voltarParaListaComodos() {
      this.comodoEmExibicao = undefined
    },

    voltarParaListaItens() {
      this.itemComodoEmExibicao = undefined;
    },

    siglaEstado(imovel){
      return ESTADOS.filter(item => {return item.id === imovel.estado.id})[0].sigla
    },

    fecharCamera() {
      this.visibilidadeCamera = false;
    },

    getLabel(data) {
      return Util.getLabel(this.statusVistoria, data)
    },

    labelData(string) {
      const data = Util.stringParaData(string);

      const diasSemana = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']
      const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

      return `${diasSemana[data.getDay()]}, ${data.getDate()} de ${meses[data.getMonth()]}`
    },

    getLatLngImovel(lat, lgn) {
      return latLng(lat, lgn)
    },

    selecionarComodo(nomeComodo) {
      this.comodoSelecionado = { nome: nomeComodo, tipo: 'GERAL' }
    },

    selecionarComodoPersonalizado() {
      this.comodoSelecionado = { nome: '', tipo: 'PERSONALIZADO' }
    },

    selecionarItemComodo(nomeItem) {
      this.itemComodoSelecionado = { nome: nomeItem, tipo: 'GERAL' }
    },

    selecionarItemComodoPersonalizado() {
      this.itemComodoSelecionado = { nome: '', tipo: 'PERSONALIZADO' }
    },

    selecionarDetalheItemPersonalizado() {
      this.detalheItemSelecionado = { nome: '' }
    },

    adicionarComodosNaLista(comodo, qtd) {
      const payload = {
        id: this.vistoriaSelecionada.id,
        comodos: []
      }

      for(let i = 0; i < qtd; i++) {
        const currentComodo = { nome: comodo.nome, ordem: this.vistoriaSelecionada.comodos.length + payload.comodos.length + 1, vistoria:{id: this.vistoriaSelecionada.id, estado: 'NAO_INFORMADO'}}
        payload.comodos.push(currentComodo);
      }
      
      this.gravarComodos(payload)
      .then(response => {
        switch(response.status) {
          case 'SUCESSO':
            this.vistoriaSelecionada.comodos.push(...response.lista);
            break;
          case 'ERRO':
            this.$message.error('Erro ao comunicar-se com o servidor.');
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.')
      });

      this.isShowPopover = false
      this.comodoSelecionado = undefined;
      this.qtdComodo = 1;
    },

    adicionarItemNaLista(item, qtd) {
      const payload = {
        id: this.comodoEmExibicao.id, 
        itens: []
      }

      for(let i = 0; i < qtd; i++) {
        const currentItem = { nome: item.nome, ordem: `${this.comodoEmExibicao.ordem}.${this.comodoEmExibicao.itens.length + payload.itens.length + 1}`, comodo: { id: this.comodoEmExibicao.id } }
        payload.itens.push(currentItem);
      }
      
      this.gravarItensComodo(payload)
      .then(response => {
        switch (response.status) {
          case 'SUCESSO':
            this.comodoEmExibicao.itens.push(...response.lista);
            break;
          case 'ERRO':
            this.$message.error(response.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.')
      });

      this.isShowPopover = false
      this.itemComodoSelecionado = undefined;
      this.qtdItem = 1;
    },

    cancelarAdicionarComodo() {
      this.comodoSelecionado = undefined;
      this.qtdComodo = 1
    },

    adicionarDetalheItemNaLista(detalhe) {
      const payload = {
        nome: detalhe.nome,
        itemComodo: {
          id: this.itemComodoEmExibicao.id
        }
      }

      this.gravarDetalheItem(payload)
      .then(response => {
        switch (response.status) {
          case 'SUCESSO':
            this.itemComodoEmExibicao.detalhes.push(response.item);
            break;
          case 'ERRO':
            this.$message.error(response.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.');
      });

      this.isShowPopover = false
      this.detalheItemSelecionado = undefined;
    },

    cancelarAdicionarItemComodo() {
      this.itemComodoSelecionado = undefined;
      this.qtdComodo = 1
    },

    cancelarAdicionarDetalheItem() {
      this.detalheItemSelecionado = undefined;
    },

    removerComodoHandler(comodo) {
      this.showLoading();
      this.$confirm('Deseja realmente remover este comodo?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {

        const payload = {
          ...comodo,
          vistoria: {
            id: this.vistoriaSelecionada.id
          }
        }

        this.removerComodo(payload)
        .then(resposta => {
          switch (resposta.status) {
            case 'SUCESSO':
              this.vistoriaSelecionada.comodos = resposta.lista;
              this.$message.success('Comodo excluído com sucesso.')
              break;
            case 'FALHA':
              this.$message.warning('Falha ao excluír o comodo.')
              break;
          }
        }).catch(() => {
          this.$message.error('Erro ao comunicar-se com o servidor.')
        });
      }).catch(() => {});
      this.hideLoading();
    },

    removerItemComodoHandler(itemComodo) {
      this.$confirm('Deseja realmente remover este item do comodo?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        const payload = {
          ...itemComodo,
          comodo: {
            id: this.comodoEmExibicao.id,
            ordem: this.comodoEmExibicao.ordem
          }
        }

        this.removerItemComodo(payload)
        .then(resposta => {
          switch (resposta.status) {
            case 'SUCESSO':
              this.comodoEmExibicao.itens = resposta.lista;
              this.$message.success('Item excluído com sucesso.')
              break;
            case 'FALHA':
              this.$message.warning('Falha ao excluír o item.')
              break;
          }
        }).catch(() => {
          this.$message.error('Erro ao comunicar-se com o servidor.')
        })
      }).catch(() => {})
    },

    removerDetalheComodoHandler(detalhe, index) {
      this.$confirm('Deseja realmente remover este detalhe de item?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerDetalheItem(detalhe)
        .then(resposta => {
          switch(resposta.status) {
            case 'SUCESSO':
              this.itemComodoEmExibicao.detalhes.splice(index, 1);
              this.$message.success(resposta.mensagem);
              break;
            case 'ERRO':
              this.$message.error(resposta.mensagem);
          }
        })
      }).catch(() => {
      })
    },

    imagemClickHandler(indice) {
      this.imagemSelecionada = indice;
    },

    imagemClickItemComodoHandler(indice) {
      this.imagemSelecionadaItemComodo = indice;
    },

    removerImagemHandler(imagem) {
      this.$confirm('Deseja realmente excluir esta imagem? A exclusão é definitiva!', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.showLoading();
        const payload = {
          ...imagem,
          idVistoria: this.vistoriaSelecionada.id,
          idComodo: this.comodoEmExibicao.id,
        }

        const index = this.comodoEmExibicao.imagens.findIndex(item => item.id === imagem.id)

        this.removerImagem(payload)
        .then(response => {
          switch (response.status) {
            case 'SUCESSO':
              this.$message.success(response.mensagem);
              this.comodoEmExibicao.imagens.splice(index, 1);
              break;
            case 'ERRO':
              this.$message.error(response.mensagem);
              break;
          }
        }).catch(() => {
          this.$message.error('Erro ao comunicar-se com o servidor')
          this.hideLoading();
        }).finally(() => {
          this.hideLoading();
        })
      }).catch(() => {})
    },

    showGravarObservacoesButton() {
      this.isShowGravarObservacoesButton = true;
    },

    hideGravarObservoesButton() {
      this.isShowGravarObservacoesButton = false;
    },

    atualizarComodoHandler() {
      const payload = {
        observacao: this.comodoEmExibicao.observacao,
        estado: this.comodoEmExibicao.estado,
        id: this.comodoEmExibicao.id
      }

      this.atualizarComodo(payload)
      .then(response => {
        switch (response.status) {
          case 'SUCESSO':
            this.isShowGravarObservacoesButton = false
            this.$message.success(response.mensagem);
            break;
          case 'ERRO':
            this.$message.error(response.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.')
      })
    },

    atualizarObservacaoGeral() {
      const payload = {
        id: this.vistoriaSelecionada.id,
        observacaoGeral: this.vistoriaSelecionada.observacaoGeral,
      };

      this.atualizarObservacoesGerais(payload)
      .then(response => {
        switch (response.status) {
          case 'SUCESSO':
            this.isShowGravarObservacoesButton = false;
            this.$message.success(response.mensagem);
            break;
          case 'ERRO':
            this.$message.error(response.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.');
      })
    },

    atualizarItemComodoHandler() {
      const payload = {
        observacao: this.itemComodoEmExibicao.observacao,
        estado: this.itemComodoEmExibicao.estado,
        id: this.itemComodoEmExibicao.id
      }

      this.atualizarItemComodo(payload)
      .then(response => {
        switch (response.status) {
          case 'SUCESSO':
            this.isShowGravarObservacoesButton = false;
            this.$message.success(response.mensagem);
            break;
          case 'ERRO':
            this.$message.error(response.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.')
      })
    },

    forceUpdate() {
      this.$nextTick(() => {
        this.$forceUpdate();
      })
    },

    exibirEditarDescricao(detalhe) {
      this.visibilidadeEditDescricao = true;

      this.detalheItemSelecionado = {...detalhe};
    },

    handleFecharEditDescricao(done) {
      done();
    },

    fecharEditDescricao() {
      this.visibilidadeEditDescricao = false;
      this.detalheItemSelecionado = undefined;
    },

    handleAtualizarDescricaoDetalhe(detalhe) {
      const payload = {
        ...detalhe,
        itemComodo: { id: this.itemComodoEmExibicao.id }
      }
      this.atualizarDescricaoDetalhe(payload)
      .then(response => {
        switch (response.status) {
          case 'SUCESSO':
            this.fecharEditDescricao();
            this.itemComodoEmExibicao.detalhes = response.lista;
            this.$message.success(response.mensagem);
            break;
          case 'ERRO':
            this.$message.error(response.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.');
      })
    },

    comodoAnterior() {
      const index = this.vistoriaSelecionada.comodos.findIndex(comodo => comodo === this.comodoEmExibicao);

      if(index > 0) {
        this.comodoEmExibicao = this.vistoriaSelecionada.comodos[index - 1];
      }
    },

    proximoComodo() {
      const index = this.vistoriaSelecionada.comodos.findIndex(comodo => comodo === this.comodoEmExibicao);

      if(index + 1 < this.vistoriaSelecionada.comodos.length) {
        this.comodoEmExibicao = this.vistoriaSelecionada.comodos[index + 1];
      }
    },

    itemComodoAnterior() {
      const index = this.comodoEmExibicao.itens.findIndex(item => item === this.itemComodoEmExibicao);

      if(index > 0) {
        this.itemComodoEmExibicao = this.comodoEmExibicao.itens[index - 1];
      }
    },

    proximoItemComodo() {
      const index = this.comodoEmExibicao.itens.findIndex(item => item === this.itemComodoEmExibicao);

      if(index + 1 < this.comodoEmExibicao.itens.length) {
        this.itemComodoEmExibicao = this.comodoEmExibicao.itens[index + 1];
      }
    },

    concluirVistoriaHandler() {
      this.$confirm('Você está prestes a concluir a vistoria, este processo é irrevesivel! Certifique-se de que a vistoria esteja realmente concluida, faça uma revisão dos comodos, dos itens e se não está faltando nenhuma foto e caso esteja tudo ok, pode prosseguir com a finalização.', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.showLoading();

        this.concluirVistoria(this.vistoriaSelecionada)
        .then(response => {
          switch (response.status) {
            case 'SUCESSO':
              this.vistoriaSelecionada.status = 'CONCLUIDO'
              this.$message.success(response.mensagem);
              this.listarVistoriasHandler();              
              break;
          
            case 'ERRO':
              this.$message.error(response.mensagem);  
              break;
          }
        }).catch(() => {
          this.$message.error('Erro ao comunicar-se com o servidor.');
          this.hideLoading(); 
        }).finally(() => {
          this.hideLoading(); 
        })
      }).catch(() => {})
    },

    urlPrimeiraImagemItemComodo(id) {
      const url = this.comodoEmExibicao.imagens.filter(imagem => {
        return imagem.idItemComodo === id;
      }).map(imagem => imagem.url)[0];

      return (url && url !== '') ? url : '';
    },

    labelTipoVistoria(label) {
      switch (label) {
        case 'ENTRADA':
          return 'Entrada'
        case 'ENTRADA_COMPLEMENTO':
          return 'Complemento.'
        case 'SAIDA':
          return 'Saída'
        case 'SAIDA_COMPLEMENTO':
          return 'Complemento.'
      }
    }
  }
}